var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6105 2.40997C19.0639 1.86334 18.1777 1.86334 17.631 2.40997L16.0508 3.99016L20.0098 7.94915L21.59 6.36897C22.1367 5.82234 22.1367 4.93609 21.59 4.38947L19.6105 2.40997Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9492 9.00984L14.9902 5.05084L4.5804 15.4606C4.31906 15.7219 4.11205 16.0325 3.97133 16.3742L2.05274 21.0336C1.94516 21.2949 2.00522 21.5952 2.205 21.795C2.40479 21.9948 2.7051 22.0548 2.96635 21.9473L7.62579 20.0287C7.96755 19.8879 8.27806 19.6809 8.5394 19.4196L18.9492 9.00984Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.ae12b9e09a5ea463f49eb0a30895a9b6.svg";
export { ForwardRef as ReactComponent };